import {
  MEASUREMENT_DECIMALS,
  MEASUREMENT_MAX_CM,
  MEASUREMENT_MIN_CM,
  MEASUREMENT_STEP_CM,
} from './measurement-constants';

const DECIMAL_PATTERN = /^\d+(?:[.,]\d+)?$/;

/**
 * Parses a typed girth. Accepts a comma or a dot as the decimal separator,
 * rounds to the 0.1 cm step the server stores, and rejects anything outside
 * the allowed range. Returns null for anything that is not a measurement.
 */
export const parseMeasurementValueCm = (raw: string): number | null => {
  const trimmed = raw.trim();
  if (!DECIMAL_PATTERN.test(trimmed)) {
    return null;
  }
  const value = Number(trimmed.replace(',', '.'));
  if (!Number.isFinite(value)) {
    return null;
  }
  const rounded = Math.round(value / MEASUREMENT_STEP_CM) * MEASUREMENT_STEP_CM;
  const normalized = Math.round(rounded * 10) / 10;
  if (normalized < MEASUREMENT_MIN_CM || normalized > MEASUREMENT_MAX_CM) {
    return null;
  }
  return normalized;
};

/** `82.5`, always one decimal, no unit. */
export const formatValueCm = (value: number): string => value.toFixed(MEASUREMENT_DECIMALS);
